import { useState, useEffect } from 'react';
import './PasswordGate.css';

export default function PasswordGate({ children }) {
  const [status, setStatus] = useState('loading'); // 'loading' | 'locked' | 'unlocked'
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  // Ask the server if this session is already authenticated
  useEffect(() => {
    fetch('/auth/status')
      .then(r => r.json())
      .then(data => setStatus(data.authenticated ? 'unlocked' : 'locked'))
      .catch(() => setStatus('locked'));
  }, []);

  const handleSubmit = async e => {
    e.preventDefault();
    if (!password.trim()) return;

    setSubmitting(true);
    setError('');

    try {
      const res = await fetch('/auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });
      const data = await res.json();

      if (data.success) {
        setStatus('unlocked');
      } else {
        setError('Incorrect password. Try again.');
        setPassword('');
      }
    } catch {
      setError('Something went wrong. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  if (status === 'loading') {
    return (
      <div className="gate-loading">
        <div className="gate-spinner"></div>
      </div>
    );
  }

  if (status === 'unlocked') {
    return children;
  }

  // Locked — show the password screen
  return (
    <div className="gate-wrap">
      <div className="gate-noise"></div>
      <div className="gate-grid"></div>

      <div className="gate-card">
        <div className="gate-logo">
          <span className="gate-logo-dot"></span>
          LIAM W <em>COACHING</em>
        </div>

        <div className="gate-divider"></div>

        <h1 className="gate-title">SITE PREVIEW</h1>
        <p className="gate-sub">
          This site is currently in private preview. Enter the access password to continue.
        </p>

        <form className="gate-form" onSubmit={handleSubmit} noValidate>
          <div className="gate-field">
            <input
              type="password"
              className={`gate-input${error ? ' gate-input--error' : ''}`}
              placeholder="Enter password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              autoFocus
              autoComplete="current-password"
              disabled={submitting}
            />
          </div>

          {error && <p className="gate-error">{error}</p>}

          <button className="gate-btn" type="submit" disabled={submitting}>
            {submitting ? 'Checking…' : 'Enter Site →'}
          </button>
        </form>

        <p className="gate-footer-note">
          Liam W Coaching &mdash; &copy; {new Date().getFullYear()}
        </p>
      </div>
    </div>
  );
}
